import axios from 'axios'

const state = {
    notification: {},
    notifications: {},
    notification_errors: {},
    notification_loading: false,
}

const getters = {
    notification: state => state.notification,
    notifications: state => state.notifications,
    notification_errors: state => state.notification_errors,
    notification_loading: state => state.notification_loading,
}

const mutations = {
    setNotification(state, notification) {
        state.notification = notification
    },
    setNotifications(state, notifications) {
        state.notifications = notifications
    },
    setNotificationErrors(state, notification_errors) {
        state.notification_errors = notification_errors
    },
    setNotificationLoading(state, notification_loading) {
        state.notification_loading = notification_loading
    },
}

const actions = {
    async storeNotification({commit}, data) {
        commit('setNotificationLoading', true)
        commit('setNotificationErrors', {})
        try {
            let response = await axios.post(`/api/notifications/store`, data)
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', error.response.data.errors)
            return false
        }
    },
    async sendNotificationMessage({commit}, data) {
        commit('setNotificationLoading', true)
        commit('setNotificationErrors', {})
        try {
            let response = await axios.post(`/api/notifications/${data.notification_id}/send-message`, data.data)
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', error.response.data.errors)
            return false
        }
    },
    async getNotifications({commit}, params) {
        try {
            let response = await axios.get(`/api/notifications`, {params})
            commit('setNotifications', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
                return false
        }
    },

    async getNotification({commit}, id) {
        try {
            let response = await axios.get(`/api/notifications/${id}/show`)
            commit('setNotification', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async selectNotification({commit}, id) {
        commit('setNotificationLoading', true)
        try {
            let response = await axios.post(`/api/notifications/${id}/select`)
            commit('setNotificationLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async updateNotification({commit}, data) {
        commit('setNotificationLoading', true)
        commit('setNotificationErrors', {})
        try {
            let response = await axios.put(`/api/notifications/${data.id}/update`, data)
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setNotificationLoading', false)
            commit('setNotificationErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}